export const ANNOTATED_IMAGE_MIME_TYPE = 'image/jpeg';
export const ANNOTATED_IMAGE_QUALITY = 0.92;
export const MAX_ANNOTATED_IMAGE_LONG_EDGE = 4096;
export const MAX_ANNOTATED_IMAGE_PIXELS = 16_000_000;
export const MAX_DEFICIENCY_IMAGE_BYTES = 25 * 1024 * 1024;
export const DEFICIENCY_IMAGE_TOO_LARGE_MESSAGE =
    'This photo is too large. Please choose an image that is 25 MB or smaller.';

export const getImageDimensions = (image) => ({
    width: image?.naturalWidth || image?.width || 0,
    height: image?.naturalHeight || image?.height || 0,
});

export const fitImageWithinBounds = (imageWidth, imageHeight, maxWidth, maxHeight) => {
    if (imageWidth <= 0 || imageHeight <= 0 || maxWidth <= 0 || maxHeight <= 0) {
        return { width: 0, height: 0 };
    }

    const scale = Math.min(maxWidth / imageWidth, maxHeight / imageHeight);
    return {
        width: imageWidth * scale,
        height: imageHeight * scale,
    };
};

export const getAnnotationExportPixelRatio = ({
    imageWidth,
    imageHeight,
    stageWidth,
    stageHeight,
}) => {
    if (imageWidth <= 0 || imageHeight <= 0 || stageWidth <= 0 || stageHeight <= 0) {
        return 1;
    }

    const originalResolutionRatio = Math.min(imageWidth / stageWidth, imageHeight / stageHeight);
    const longEdgeRatio = MAX_ANNOTATED_IMAGE_LONG_EDGE / Math.max(stageWidth, stageHeight);
    const pixelCountRatio = Math.sqrt(MAX_ANNOTATED_IMAGE_PIXELS / (stageWidth * stageHeight));

    return Math.min(originalResolutionRatio, longEdgeRatio, pixelCountRatio);
};

export const getJpegFilename = (filename = 'image') => {
    const baseName = filename.replace(/\.[^/.]+$/, '') || 'image';
    return `${baseName}.jpg`;
};

export const getDataUrlByteSize = (dataUrl = '') => {
    const commaIndex = dataUrl.indexOf(',');
    if (commaIndex < 0) return 0;

    const base64 = dataUrl.slice(commaIndex + 1);
    const padding = base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0;
    return Math.max(0, Math.floor((base64.length * 3) / 4) - padding);
};
